import VenueDetailModal from '@/components/venue-detail-modal';
import { Button } from 'antd';
import React, { useState } from 'react';
import CreateTowerProject from '../create-tower-project';
import { formateTimeStamp } from '@/common/utils';
import './index.less';
import env from '@/env';
interface TowerBannerProps {
  cardItem: any;
  refresh?: () => void;
  roomId: string;
  power: any;
}

function TowerBanner({ cardItem, refresh, roomId, power }: TowerBannerProps) {
  const [avenueLinkVisible, setAvenueLinkVisible] = useState(false);
  const BABEL_URL = env.BABEL_DOMAIN + '/active/babelCommon/index.html#/';
  const {
    tower_activity_change = 0,
    tower_activity_entrance = 0,
    tower_activity_link = 0,
    tower_data_display = 0,
  } = power ? power : {};

  function toLookData() {
    const { id, encryptActivityId, name, item } = cardItem;
    const targetUrl =
      BABEL_URL +
      'dataCenterDetail/baseData?activityId=' +
      id +
      '&encryActivityId=' +
      encryptActivityId +
      '&activityName=' +
      name +
      '&activityType=' +
      item +
      '&activeTab=baseData';
    window.open(targetUrl);
  }

  function toBabel() {
    window.open(BABEL_URL);
  }

  function getStatus(status: string) {
    switch (status) {
      case '1':
        return '未开始';
      case '2':
        return '进行中';
      case '3':
        return '已过期';
      case '4':
        return '已下线';
    }
  }

  function getColor(status: string) {
    if (status === '2') {
      return {
        color: '#2d64ff',
        background: '#F3F6FF',
        border: '1px solid #CFE2FF',
      };
    }
    return {
      color: 'rgba(0, 0, 0, 0.45)',
      background: 'rgba(0, 0, 0, 0.06)',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    };
  }

  return (
    <div className="tower-banner__wrapper">
      <div className="tower-banner__detail__wrapper">
        <div className="tower-banner__detail__title__wrapper">
          <div className="tower-banner__detail__title__label" style={getColor(cardItem.status)}>
            {getStatus(cardItem.status)}
          </div>
          <div className="tower-banner__detail__title__name">{cardItem.name}</div>
        </div>
        <div className="tower-banner__detail__info">
          <span>项目ID：{cardItem.id}</span>
          <span style={{ paddingLeft: 21 }}>创建人ERP：{cardItem.createErp}</span>
          <span style={{ paddingLeft: 23 }}>
            活动时间：{formateTimeStamp(cardItem.startTime, true)} 至 {formateTimeStamp(cardItem.endTime, true)}
          </span>
        </div>
      </div>
      <div className="tower-banner__button-group">
        {tower_activity_link === 1 && (
          <>
            <Button
              onClick={() => {
                setAvenueLinkVisible(true);
              }}
              style={{ marginLeft: 20 }}
            >
              会场链接
            </Button>
            <VenueDetailModal
              avenueLinkVisible={avenueLinkVisible}
              setAvenueLinkVisible={setAvenueLinkVisible}
              cardItem={cardItem}
            />
          </>
        )}
        {tower_data_display === 1 && (
          <Button onClick={toLookData} style={{ marginLeft: 20 }}>
            查看数据
          </Button>
        )}
        {tower_activity_entrance === 1 && (
          <Button onClick={toBabel} style={{ marginLeft: 20 }}>
            进入通天塔
          </Button>
        )}
        {tower_activity_change === 1 && <CreateTowerProject type={2} roomId={roomId} refresh={refresh} />}
      </div>
    </div>
  );
}

export default TowerBanner;
